import { render, staticRenderFns } from "./companyInvitationFeedback.vue?vue&type=template&id=852231d4&"
import script from "./companyInvitationFeedback.vue?vue&type=script&lang=js&"
export * from "./companyInvitationFeedback.vue?vue&type=script&lang=js&"
import style0 from "./companyInvitationFeedback.vue?vue&type=style&index=0&id=852231d4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports